module.exports = __webpack_public_path__ + "media/pdf/smp/Konditionen_SCHUFA-Plattform-fa3d3abd5ea0f957e2b3930700d53f70.pdf";